// import axios from "axios";
import store from "../store";
import router from "../router";
import CryptoJS from 'crypto-js'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_URL, // api 的 VUE_APP_URL
  timeout: 50000 // 请求超时时间(因为需要调试后台,所以设置得比较大)
});

const kstr = CryptoJS.enc.Utf8.parse("xtcproperty4aes2");
const kiv = CryptoJS.enc.Utf8.parse('xtcproperty4aes2');

//AES加密
function encryptAes(word) {
  let srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, kstr, {
    iv: kiv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}
//AES 解密
function decryptAes(word) {
  let base64 = CryptoJS.enc.Base64.parse(word);
  let src = CryptoJS.enc.Base64.stringify(base64);
  var decrypt = CryptoJS.AES.decrypt(src, kstr, {
    iv: kiv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });
  var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}


// request拦截器,在请求之前做一些处理
// service.interceptors.request.use(
//   config => {
//     if (store.state.token) {
//       // 给请求头添加laohu-token
//       config.headers["user-token"] = store.state.token;
//     }
//     return config;
//   },
//   error => {
//     console.log(error); // for debug
//     Promise.reject(error);
//   }
// );

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['Authorization'] = getToken()
    }

    if(config.data && config.data!='' && !config.unencrypt){
      // console.info('config.data:'+JSON.stringify(config.data))
      config.data = encryptAes(JSON.stringify(config.data))
      // console.info('config.data aes加密后:'+config.data)
      config.headers['Content-Type']  = 'text/plain'
    }
    
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)



// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    if (res.code === 2) {
      // to re-login
      MessageBox.confirm('登录状态已过期，您可以重新登录', '确认退出', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        store.dispatch('user/resetToken').then(() => {
          location.reload()
        })
      })
    } else {
      return res
    }
  },
  error => {
    if (error.response.status === 401) {
      // to re-login
      MessageBox.confirm('鉴权失败，您可以重新登录', '确认退出', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        store.dispatch('user/resetToken').then(() => {
          location.reload()
        })
      })
    }
    return Promise.reject(error)
  }
)
export default service;
